const spinnerHTML = `
  <div class="bg-black bg-opacity-40 fixed flex items-center justify-center top-0 bottom-0 right-0 left-0 z-[1000]">
    <div class="spinner">
      <div class="double-bounce1"></div>
      <div class="double-bounce2"></div>
    </div>
  </div>
`

export const showSpinner = (container: HTMLElement) => {
  container.insertAdjacentHTML('beforeend', spinnerHTML)
}

export const hideSpinner = (container: HTMLElement) => {
  const spinner = container.querySelector('.bg-black.bg-opacity-40')
  if (spinner) {
    spinner.remove()
  }
}
